import React from 'react';
import { Card, CardMedia, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';

const StyledCardMedia = styled(CardMedia)({
    // paddingTop: '56.25%', // 16:9
    paddingTop: '100%',
    height: '100%',
    objectFit: 'cover'
});

const StyledCardVideo = styled('video')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
});

const TruncatedTypography = styled(Typography)({
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    wordBreak: "break-all",
    overflow: "hidden",
});

const StyledLink = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
    display: 'block', // This is important to make the link occupy the full space of the Card
});

const Pet = ({ pet }) => (
    <StyledLink to={`/petprofile/${pet.slug}`}>
        <Card
            sx={{
                maxWidth: '100%',
                height: '360px',
                boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                backgroundColor: '#f2f2f2',
                borderRadius: '15px',
                border: '2px solid #FFFFFF00'
            }}>
            {pet.fileUrl && pet.fileUrl.endsWith('.mp4') ? (
                <StyledCardVideo controls>
                    <source src={pet.fileUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </StyledCardVideo>
            ) : (
                <StyledCardMedia
                    image={pet.fileUrl ? pet.fileUrl : "https://via.placeholder.com/640x360"}
                    title="Pet image"
                />
            )}
            <CardContent>
                <TruncatedTypography
                    variant="body2"
                    color="#16cc7d"
                >
                    {pet.name}
                </TruncatedTypography>
            </CardContent>
        </Card>
    </StyledLink>
);

export default Pet;
